<template>
    <div v-if="dt.uuid" class="container-fluid rounded doc-type-members-container">
        <div class="row border-bottom p-3">
            <div class="col-6 align-self-center font-20 text-semi-bold">
                User access
            </div>
            <div class="col-6 align-self-center text-right pl-0">
                <div class="input-group">
                    <input v-model="searchQuery"
                           type="text"
                           class="form-control form-control-sm"
                           placeholder="Search user"
                           aria-describedby="search-member">
                    <div class="input-group-append">
                        <button class="btn btn-sm btn-outline-primary mr-1"
                                style="width: 40px;"
                                @click="addUser"
                                v-tooltip="'Add user'">
                            <i class="fal fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="filteredPermissionsList.length === 0" class="text-muted p-3">
            No data
        </div>
        <VirtualList
            v-else
            :data-key="item => item.user.uuid"
            :data-sources="filteredPermissionsList"
            :data-component="virtualListComponent"
            :keeps="10"
            :estimate-size="55"
            id="permission-list"
            class="list-group scrollable"
            style="max-height: 370px; overflow-y: auto;"/>

        <DtAddUsers name="add-user" :users="notAddedUsers" :onAdd="onAddUsers"/>
    </div>
</template>
<script>
import VirtualList from 'vue-virtual-scroll-list'
import {mapGetters, mapMutations} from 'vuex'
import DtPermissionMemberRow from './DtPermissionMemberRow'
import DtAddUsers from './DtAddUsers'
import {DOCS_TYPES_SELECTED_UPDATE_PROP, DOCS_TYPES_SET} from '@/store/modules/documents'
import {AppDocPermissions} from '@/types/permissions/document'
import {documentTypesApiService} from '@/api/document/types'

export default {
    name: 'DtPermissionMembers',
    components: {DtAddUsers, VirtualList},
    data() {
        return {
            searchQuery: '',
            virtualListComponent: DtPermissionMemberRow
        }
    },
    computed: {
        ...mapGetters([
            'getMembers',
            'getActiveMembers'
        ]),

        ...mapGetters('documents', {
            dt: 'documentTypeSelected',
            documentTypes: 'documentTypes'
        }),

        ...mapGetters('doc_type_permissions', [
            'selectedDocTypePermissions'
        ]),

        permissionsList() {
            return Object.entries(this.selectedDocTypePermissions).map(([userUuid, permission]) => ({
                user: this.getMembers.find(m => m.uuid === userUuid),
                permission
            }))
        },

        filteredPermissionsList() {
            return this.permissionsList.filter(p => p.user && (
                String(p.user.firstName).toLowerCase().startsWith(this.searchQuery.toLowerCase()) ||
                String(p.user.lastName).toLowerCase().startsWith(this.searchQuery.toLowerCase())))
        },

        notAddedUsers() {
            return this.getActiveMembers.filter(m => !this.selectedDocTypePermissions[m.uuid])
        }
    },
    methods: {
        ...mapMutations('documents', {
            updateDtProp: DOCS_TYPES_SELECTED_UPDATE_PROP,
            setDocTypes: DOCS_TYPES_SET
        }),

        addUser() {
            this.$modal.show('add-user')
        },

        onAddUsers(users = []) {
            const promises = []
            const permission = AppDocPermissions.FULL

            users.forEach(user => {
                promises.push(documentTypesApiService.addUser({id: this.dt.uuid, user, permission}))
            })

            return Promise.all(promises).then(() => {
                // update selected dt data
                let permissions = _.cloneDeep(this.selectedDocTypePermissions)
                users.forEach(user => {
                    permissions[user.uuid] = permission
                })
                this.updateDtProp({path: 'permissions', data: permissions})

                // TODO: pure update with mutation
                const dIdx = this.documentTypes.findIndex(dt => dt.uuid === this.dt.uuid)
                if (dIdx !== -1) {
                    this.documentTypes[dIdx].permissions = permissions
                }
                this.setDocTypes(this.documentTypes)
            })
                .catch(error => {
                    this.$snackbar.show({error})
                })
        }
    }
}
</script>

<style scoped lang="scss">
.doc-type-members-container {
    height: calc(100% - 80px);
    background: white;
    overflow-y: scroll;
}

#permission-list {
    height: 400px;
}
</style>
